<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0004 21.3723C10.3224 21.3723 8.78199 20.813 7.79031 19.9775C7.28663 20.1275 6.64236 20.3685 6.23591 20.6677C5.88795 20.9234 5.93131 21.1842 5.99404 21.2894C6.26931 21.7521 10.7165 21.5849 12.0004 21.4408V21.3723Z"
      fill="currentColor"
    />
    <path
      d="M12.0005 21.3723C13.6787 21.3723 15.2189 20.813 16.2107 19.9775C16.7142 20.1275 17.3585 20.3685 17.7651 20.6677C18.1129 20.9234 18.0696 21.1842 18.0068 21.2894C17.7316 21.7521 13.2844 21.5849 12.0005 21.4408V21.3723Z"
      fill="currentColor"
    />
    <path
      d="M12.0102 11.3565C14.7814 11.3378 17.0022 10.8037 17.7548 10.5988C17.9341 10.5499 18.03 10.4623 18.03 10.4623C18.0308 10.4371 18.0415 10.013 18.0415 9.7942C18.0415 6.10987 16.295 2.40753 11.9999 2.40735C7.70496 2.40753 5.9585 6.10987 5.9585 9.7942C5.9585 10.013 5.9692 10.4371 5.96993 10.4623C5.96993 10.4623 6.04798 10.5442 6.19096 10.5839C6.88578 10.7765 9.14847 11.3372 11.9897 11.3565H12.0102Z"
      fill="currentColor"
    />
    <path
      d="M19.5404 14.4259C19.3687 13.8754 19.1342 13.2334 18.8967 12.6168C18.8967 12.6168 18.7602 12.6001 18.691 12.6199C16.5604 13.2364 13.978 13.6292 12.0101 13.6055H11.9897C10.0327 13.6288 7.4678 13.2406 5.34441 12.6302C5.26323 12.6069 5.10308 12.6168 5.10308 12.6168C4.86564 13.2334 4.63114 13.8754 4.45937 14.4259C3.6402 17.0512 3.90569 18.1376 4.10772 18.1621C4.54129 18.2142 5.79551 16.1858 5.79551 16.1858C5.79551 18.2469 7.6641 21.4118 11.9432 21.4409C11.9622 21.4407 12.0376 21.4407 12.0566 21.4409C16.3357 21.4118 18.2043 18.2469 18.2043 16.1858C18.2043 16.1858 19.4585 18.2142 19.8921 18.1621C20.0941 18.1376 20.3596 17.0512 19.5404 14.4259Z"
      fill="currentColor"
    />
    <path
      d="M10.4718 7.85059C9.88911 7.87686 9.39134 7.21577 9.35997 6.37553C9.32842 5.53474 9.77472 4.83194 10.3574 4.80567C10.9395 4.77976 11.4371 5.44049 11.4686 6.28109C11.5005 7.12188 11.054 7.82468 10.4718 7.85059Z"
      fill="currentColor"
    />
    <path
      d="M14.6398 6.37553C14.6087 7.21577 14.1109 7.87686 13.5282 7.85059C12.946 7.8245 12.4995 7.12188 12.5314 6.28109C12.5629 5.44049 13.0605 4.77976 13.6426 4.80567C14.2253 4.83194 14.6716 5.53474 14.6398 6.37553Z"
      fill="currentColor"
    />
    <path
      d="M15.6754 9.03729C15.5197 8.69389 13.9516 8.31116 12.0103 8.31116H11.9895C10.0482 8.31116 8.48014 8.69389 8.32443 9.03729C8.31742 9.05218 8.31299 9.06871 8.31299 9.08617C8.31299 9.11097 8.32148 9.1332 8.33439 9.15231C8.46575 9.34267 10.2069 10.284 11.9895 10.284H12.0103C13.793 10.284 15.5341 9.34285 15.6652 9.15231C15.6783 9.13339 15.6866 9.11079 15.6866 9.08598C15.6866 9.06853 15.6824 9.05218 15.6754 9.03729Z"
      fill="currentColor"
    />
    <path
      d="M11.1878 6.38784C11.2144 6.71986 11.0316 7.01476 10.7799 7.04692C10.5279 7.07925 10.3022 6.83635 10.2755 6.50415C10.2491 6.17195 10.4318 5.87705 10.6829 5.84508C10.9354 5.81256 11.1614 6.05583 11.1878 6.38784Z"
      fill="currentColor"
    />
    <path
      d="M12.7888 6.49881C12.8402 6.40694 13.191 5.92389 13.917 6.09972C14.1077 6.14603 14.1959 6.21401 14.2146 6.24065C14.2421 6.28016 14.2496 6.33638 14.2218 6.41208C14.1666 6.5622 14.0526 6.55815 13.9895 6.52875C13.9487 6.50983 13.443 6.17414 12.9771 6.67501C12.945 6.70937 12.8877 6.72113 12.8334 6.68034C12.779 6.63937 12.7567 6.5565 12.7888 6.49881Z"
      fill="currentColor"
    />
    <path
      d="M12.0102 13.4846H11.9897C10.6513 13.5008 9.02867 13.3242 7.45712 13.0157C7.32262 13.7914 7.24144 14.7665 7.31118 15.9294C7.48737 18.8685 9.24011 20.716 11.9454 20.7428H12.0554C14.7608 20.716 16.5134 18.8685 16.6898 15.9294C16.7595 14.7664 16.6781 13.7914 16.5436 13.0155C14.9719 13.3242 13.3489 13.5008 12.0102 13.4846Z"
      fill="currentColor"
    />
    <path
      d="M8.198 13.2388V16.1312C8.198 16.1312 9.52841 16.3983 10.8614 16.2133V13.5454C10.017 13.4978 9.10628 13.3918 8.198 13.2388Z"
      fill="currentColor"
    />
    <path
      d="M18.0301 10.4623C18.0301 10.4623 15.4422 11.2759 12.0103 11.299H11.9898C8.56353 11.2761 5.9789 10.465 5.97004 10.4623L5.10327 12.6168C7.27131 13.2678 9.95816 13.6873 11.9898 13.6628H12.0103C14.042 13.6873 16.7287 13.2678 18.8969 12.6168L18.0301 10.4623Z"
      fill="currentColor"
    />
  </svg>
</template>
